/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/alt-text */
import React, { useEffect, useMemo } from 'react';
import { Container } from 'react-bootstrap';
import SearchIcon from '@mui/icons-material/Search';
import SettingsIcon from '@mui/icons-material/Settings';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import FormLabel from '@mui/joy/FormLabel';
import TextInput from 'components/input/textInput';
import LoadingContent from 'components/LoadingContent';
import SelectInput from 'components/input/SelectInput';
import { useFormik } from 'formik';
import { useHistory, useLocation } from 'react-router-dom';
import { appRoutes, routers } from 'router/router';
import { useAppDispatch } from 'app/hooks';
import wpGeodirServices from "services/wpGeodirServices";
import { logout } from 'app/basicInformationSlice/basicInformationSlice';
import { getAccessToken, getUserId, removeAccessToken, removeUserId } from 'utils/sessionStorage';

/** Map legacy URL values (numeric id) to category name for API params. */
function resolveCategoryForApi(raw: string, categoriesList: any[]): string {
  if (!raw || !categoriesList?.length) return raw;
  const trimmed = String(raw).trim();
  const byId = categoriesList.find((c) => String(c.id) === trimmed);
  if (byId?.name != null) return String(byId.name);
  return trimmed;
}

interface Props {}

const CategoryPage = (props: Props) => {
  const [loading, setLoading] = React.useState(false);
  const [isMobile, setIsMobile] = React.useState<boolean>(window.innerWidth <= 768);
  const dispatch = useAppDispatch();
  const history = useHistory();
  const location = useLocation();
  const [pageTitle, setPageTitle] = React.useState('');
  const [categories, setCategories] = React.useState<any[]>([]);
  const [categoryOptions, setCategoryOptions] = React.useState<any[]>([]);
  const [showCategories, setShowCategories] = React.useState(false);
  const [programs, setPrograms] = React.useState<any[]>([]);
  // const [count, setCount] = useState<any>(0);
  // const [sort, setSort] = useState('id:ASC');
  // const [perPage, setPerPage] = useState<any>(10);
  // const [page, setPage] = useState<any>(1);
 
  let query = new URLSearchParams(useLocation().search);  
  // let geodir_search = query.get('geodir_search');
  let search_title = query.get('name') || '';
  let search_category = query.get('id') || '';
  let search_offer_in = query.get('offer_in') || '';
  let search_grades = query.get('grades') || '';
  let search_format = query.get('format') || '';
  let studentId = getUserId();
  let token = getAccessToken();

  const formik = useFormik({
    initialValues: {
        title: search_title,
        category: search_category,
        offer_in: search_offer_in,
        grades: search_grades,
        format: search_format,
      },
      onSubmit: async (values) => {
        studentId = getUserId();
        token = getAccessToken();
        if (token && studentId) {
          await handleSearch();
          showOptions();
        } 
        else {
            handleLogout();
        }
      },
  });

  const handleLogout = () => {
    dispatch(logout());
    removeAccessToken();
    removeUserId();
    history.push(routers.login.path);
  };

  const initSearch = async () =>{
    search_title = query.get('name') || '';
    search_category = query.get('id') || '';
    search_offer_in = query.get('offer_in') || '';
    search_grades = query.get('grades') || '';
    search_format = query.get('format') || '';    
    formik.resetForm({values: {
      title: search_title,
      category: search_category,
      offer_in: search_offer_in,
      grades: search_grades,
      format: search_format 
    }});
    showOptions();
  }
  const renderCategories = useMemo(() => {
    const itemsPerRow = 4;
    const rows: JSX.Element[] = [];    
    for (let i = 0; i < categories.length; i += itemsPerRow) {
        const columns: JSX.Element[] = [];

        for (let j = 0; j < itemsPerRow; j++) {
            const currentIndex = i + j;
            if (currentIndex < categories.length) {
                const item = categories[currentIndex];
                columns.push(
                  <div key={item.id} className="col">
                    <div className="gd-cptcat-btn" data-id={item.id}>
                      <span className="gd-cptcat-cat-link">
                        <a className="text-decoration-none" href={item.link} title={item.name} target="_blank" rel="noopener noreferrer" > {item.name}
                          <span className="px-1"> <span className="gd-cptcat-count">{item.count}</span></span>
                        </a>
                      </span>
                    </div>
                  </div>
                );
            }
        }

        rows.push(
          <div key={i} className="row normal py-2">
            {columns}
          </div>
        );
    }    
    return rows;
}, [categories]);

  const onClickDetail = (item:any) => {
    let search_query = `id=${item.id}`;
    history.push({
      pathname: appRoutes.eduProgram.path, 
      search: search_query,
    });
  }

  const renderPrograms = useMemo(() => {
    const itemsPerRow= 3;
    const rows: JSX.Element[] = [];    
    for (let i = 0; i < programs.length; i += itemsPerRow) {
        const columns: JSX.Element[] = [];

        for (let j = 0; j < itemsPerRow; j++) {
            const currentIndex = i + j;
            if (currentIndex < programs.length) {
                const item = programs[currentIndex];
                //console.log('item:', item);
                let default_category = item?.default_category || '';
                let categoryObj = null;
                if (formik.values.category) {
                  categoryObj = categories.find((o:any)=> o.name === formik.values.category);
                }
                else {
                  categoryObj= categories.find((o:any)=> o.id === Number(default_category));
                }
                //let category_url = categoryObj ? categoryObj.link || '' : '';
                let category_url = `${window.location.origin}/#/programs/category?id=${categoryObj.id}`;
                let category_name = categoryObj ? categoryObj.name || '' : '';
                let item_title = item?.post_title ?? '';
                let item_offer_in = item?.offer_in ?? <span>&nbsp;</span>;
                let item_grades = item?.grades ?? <span>&nbsp;</span>;
                let item_format = item?.format ?? <span>&nbsp;</span>;
                columns.push(
                  <div key={`program_${item.id}`} className="col-md-4">
                    <div className="container border shadow bg-white py-4"
                      style={{borderRadius:'8px', minHeight: '410px'}}
                    >
                      <div className="row normal">
                        <div className="col-md-12">
                          <div className="geodir-post-meta-heading d-flex">
                            <div className="geodir-field-default_category">
                            <a href={category_url}>{category_name}</a>
                            </div>
                          </div>
                        </div>
                      </div> 
  
                      <div className="row normal pt-4 pb-2">
                        <div className="col-md-12">
                        <h4 className="geodir-field-post_title">{item_title}</h4>
                        </div>
                      </div>                 
  
                      <div className="row normal">
                        <div className="col-md-12">
                        <h5 className="geodir-field-label">Offered in:</h5>
                        <div className="geodir-field-post_offer_in">{item_offer_in}</div>
                        </div>
                      </div>
  
                      <div className="row normal py-4">
                        <div className="col-md-7">
                          <h5 className="geodir-field-label">Grades:</h5>
                          <div className="geodir-field-value">{item_grades}</div>   
                        </div>
  
                        <div className="col-md-5">
                          <h5 className="geodir-field-label">Format:</h5>
                          <div className="geodir-field-value">{item_format}</div>   
                        </div>
                      </div>
  
                      <div className="row text-center py-2 mt-2">
                        <div className="col">
                          <button className="btn btn-primary fs-16px" 
                              style={{width:'120px', height:'48px'}}                              
                              onClick={()=>onClickDetail(item)}
                          >
                            Details
                          </button>
                        </div>
                      </div>
  
                    </div>
                 </div>
                );
            }
        }

        rows.push(
            <div key={i}className="row py-4">
              <div className="col-md-12 row normal py-2">
              {columns}
              </div>
            </div>          
        );
    }    
    return rows;
  }, [programs, categories, formik.values.category]);

  const loadPrograms = async (categoryList?: any[], categoryForApi?: string) => {
    try {
        studentId = getUserId();
        token = getAccessToken();
        if (token && studentId) {

          setLoading(true);
          const list = categoryList ?? categories;
          const categoryResolved =
            categoryForApi ?? resolveCategoryForApi(formik.values.category, list);
          const body = {
            title: formik.values.title,
            category: categoryResolved,
            offer_in: formik.values.offer_in,
            grades: formik.values.grades,
            format: formik.values.format
          };
          let ret:any =  await wpGeodirServices.getProgramList(body);
          if (ret) {
            if (ret.data) {
              setPrograms(ret.data);
            }
            else {
              setPrograms([]);
            }
            // if (ret.count) {
            //   setCount(ret.count);
            // }
            // else{
            //   setCount(0);
            // }
          }
          setLoading(false);
        } 
        else {
          handleLogout();
        }
    }
    catch(ex){
      setLoading(false);
      console.log('Error:',ex);
    }    
  }

  const loadCategories = async(): Promise<any[]> => {
    try {
      studentId = getUserId();
      token = getAccessToken();
      if (token && studentId) {
        setLoading(true)
        let list:any[] = await wpGeodirServices.getCategories();
        // console.log('getCategories() ~ list:', list);
        let arr:any[] = (list || []).map((item)=> {
            return { value: item.name != null ? String(item.name) : '', name: item.name }
        })
        arr.splice(0, 0, { value: '', name: '- All Programs -'});
        setCategoryOptions(arr);
        setCategories(list);
  
        if (search_category) {
          let categoryObj = list.find((o:any)=> o.id === Number(search_category));
          let category_name = categoryObj ? categoryObj.name || '' : '';
          setPageTitle(`All ${category_name}`);
        }
        setLoading(false);
        return list || [];
      } 
      else {
          handleLogout();
          return [];
      }    
    }
    catch(ex){
      setLoading(false);
      return [];
    }    
  };

  const loadData = async() => {
    await initSearch();
    const list = await loadCategories();
    const urlCat = query.get('id') || '';
    const resolved = resolveCategoryForApi(urlCat, list);
    formik.setFieldValue('category', resolved);
    await loadPrograms(list, resolved);
  }
  // Handle responsive detection
  const handleResize = () => {
    setIsMobile(isMobile);
  };

  useEffect(() => {
    setShowCategories(false);
    loadData();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, [location]);

  const handleSearch = async () => {
    query.delete('id');
    query.set('geodir_search', '1');

    if (formik.values.category) {
      query.set('category', formik.values.category);
     }
     else {
      query.delete('category');
     }
 
     if (formik.values.title) {
       query.set('name', formik.values.title);
     }
     else {
      query.delete('name');
     }
 
     if (formik.values.offer_in) {
       query.set('offer_in', formik.values.offer_in);
     }
     else {
      query.delete('offer_in');
     }
 
     if (formik.values.grades) {
       query.set('grades', formik.values.grades);
     }
     else {
      query.delete('grades');
     }
  
     if (formik.values.format) {
       query.set('format', formik.values.format);
     }
     else {
      query.delete('format');
     }
   
    history.push({
      pathname:  appRoutes.summerProgramsBrowser.path,
      search: query.toString(),
    });

    await loadPrograms();
  }

  const handleEnterKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault(); // Prevent default behavior if needed
      formik.handleSubmit();
    }
  };

  const toglgeShowOptions= () => {
    var ele:any = document.getElementById("dv_options");
    if (ele) {
      if (ele.style.display === 'none') {
        ele.style.display = 'block';
      }
      else {
        ele.style.display = 'none';
      }
    }
  }

  const showOptions = () => {
    var bShow = false;
    if (search_offer_in || search_grades || search_format ) {
      bShow = true;
    }
    if (formik.values.offer_in || formik.values.grades || formik.values.format) {
      bShow = true;
    }
    var ele:any = document.getElementById("dv_options");
    if (ele) {
      if (bShow) {
        ele.style.display = 'block';
      }
      else {
        ele.style.display = 'none';
      }
    }
    
  };

  return (
    <>
      <Container
        className="border bg-white shadow d-flex flex-column align-items-center"
        style={{
          padding: isMobile ? '.75rem' : '1.25rem',
          margin: '0 auto',
          minHeight: isMobile ? '100%' : 'calc(100% - 60px)',
        }}
      >
      {loading ? (
          <LoadingContent />
        ) : (

          <div style={{ width: '100%', maxWidth: '75rem' }}>
            <div className="row normal py-4">
              <div className="col">
                <h2 className="title">{pageTitle}</h2>
              </div>
            </div>

            <div className="row normal pt-2 pb-4">
                <div className="col-md-4">
                  <SelectInput
                    form={formik}
                    label="Category :"
                    name="category"
                    option={categoryOptions}
                    renderValue={(o:any)=> o.label}
                    values={formik.values.category}
                    onChange={(e:any) => {
                       formik.handleChange(e);
                      }}
                    feedback={
                      formik.errors.category && (
                        <span className="text-danger">{formik.errors.category}</span>
                      )
                    }
                  />
                </div>
                <div className="col-md-8 row d-flex justify-content-center align-items-end">
                    <div className="col-md-9">
                      <div style={{marginBottom: '2px'}}>
                        <FormLabel
                          htmlFor="title"
                          className={`label-14px p-0`}
                          sx={{
                            display: 'inline',
                            alignItems: 'center',
                            fontSize: '14px',
                            fontWeight: '500',
                            marginBottom: '1px !important',
                          }}
                        >
                          <span>Search program :</span>
                        </FormLabel>
                      </div>
                     <TextField
                        className="text-field w-100"
                        name={'title'}
                        variant="outlined" // Can also be 'filled' or 'standard'
                        onChange={(e: any) => {
                          formik.handleChange(e);
                        }}
                        onKeyDown={handleEnterKeyPress}
                        placeholder="Search program"
                        value={formik.values.title}
                        InputProps={{
                          style: {
                            height: '50px', // Sets the height of the main container
                          },
                          startAdornment: (
                            <InputAdornment position="start">
                              <SearchIcon />
                            </InputAdornment>
                          ),
                        }}
                        sx={{
                          '& .MuiOutlinedInput-notchedOutline': {
                            borderColor: "rgb(205, 215, 225)",
                            borderRadius: "0.5rem",
                            borderWidth: '1px',
                            boxShadow: "rgb(0, 0, 0) 0px 0px 0px 0px, rgba(21, 21, 21, 0.08) 0px 1px 2px 0px",
                            boxSizing: "border-box"
                          }
                        }}

                      />
                    </div>
                    <div className="col-md-3">
                      <button 
                        className="btn btn-primary" 
                        style={{width:'calc(50% - 0.5rem)', marginLeft: '0.5rem'}}
                        onClick={()=>formik.handleSubmit()}
                        title="Search"
                        >
                        <SearchIcon
                          style={{
                            color: '#fff',
                            height: '38px',
                          }}
                        />
                      </button>
                      <button 
                        className="btn btn-primary" 
                        style={{width:'calc(50% - 0.5rem)', marginLeft: '0.5rem'}}
                        onClick={toglgeShowOptions}
                        title="More options"
                        >
                        <SettingsIcon
                          style={{
                            color: '#fff',
                            height: '38px',
                          }}
                        />
                      </button>
                    </div>
                </div>
            </div>

            <div id="dv_options" className="border shadow pt-3 pb-4" style={{display: 'none', background: '#F4F4F4'}}>
              <div className="row normal g-5 animated-fadeInOut" >
                <div className="col-md-4">
                  <TextInput
                    label="Offered in"
                    name="offer_in"
                    placeholder="Offered in"
                    values={formik.values.offer_in}
                    onChange={formik.handleChange}
                  />
                </div>
                <div className="col-md-4">
                  <TextInput
                    label="Grades"
                    name="grades"
                    placeholder="Grades"
                    values={formik.values.grades}
                    onChange={formik.handleChange}
                  />
                </div>
                <div className="col-md-4">
                  <TextInput
                    label="Format"
                    name="format"
                    placeholder="Format"
                    values={formik.values.format}
                    onChange={formik.handleChange}
                  />
                </div>
              </div>
            </div>

            {showCategories && (
              <>
                <div className="row normal py-4 mt-5">
                    <div className="col">
                        <h3 className="sub-title">Program Categories</h3>
                    </div>
                </div>

                {categories && categories.length>0 && (
                  <>
                    {renderCategories}
                  </>
                )}                
              </>                
            )}
            {programs && programs.length>0 && (
              <>
              <hr/>
              {renderPrograms}
              </>
            )}
          </div>
      )}
      </Container>
    </>
  );
};

export default CategoryPage;
